module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/transbanklogo.4e55d4d6.svg";